import RejectReasonSimpleForm from './RejectReasonSimpleForm'

export default RejectReasonSimpleForm
